var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconContrastAltH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000069376865017332091680000012370226146901233554_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114 114",
    style: {
      enableBackground: "new 0 0 114 114"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,80.3c-12.8,0-23.3-10.4-23.3-23.3S44.2,33.7,57,33.7S80.3,44.2,80.3,57S69.9,80.3,57,80.3z M57,37.7 c-10.6,0-19.3,8.7-19.3,19.3S46.4,76.3,57,76.3S76.3,67.6,76.3,57S67.6,37.7,57,37.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,35.7c11.8,0,21.3,9.5,21.3,21.3S68.8,78.3,57,78.3V35.7L57,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,101.1c-0.3,0-0.7,0-1,0l0.2-10.9c1.3,0,2.7,0,4-0.2h0.2l0.3,4.5l0.7,6.4h-0.1 C59.8,101,58.4,101.1,57,101.1L57,101.1z M87.4,88.9L79.9,81c1-0.9,1.9-1.9,2.8-3l8.4,6.9C89.9,86.3,88.7,87.7,87.4,88.9 L87.4,88.9z M13.2,61.4L13.2,61.4c-0.2-1.5-0.2-3-0.2-4.5c0-0.3,0-0.6,0-1l10.9,0.2c0,0.2,0,0.5,0,0.7c0,1.1,0.1,2.2,0.2,3.3v0.2 l-3.5,0.2L13.2,61.4L13.2,61.4z M101.1,58.1l-10.9-0.3c0-0.3,0-0.5,0-0.8c0-1.1-0.1-2.2-0.2-3.3l10.9-1.3v0.2 c0.1,1.4,0.2,2.8,0.2,4.3C101.1,57.4,101.1,57.7,101.1,58.1L101.1,58.1z M31.3,36l-8.5-6.9c1.1-1.4,2.4-2.7,3.7-4l7.6,7.9 C33.1,34,32.2,35,31.3,36L31.3,36z M53.8,24l-1.2-10.9h0.2c1.7-0.2,3.5-0.2,5.3-0.2l-0.2,10.9C56.4,23.8,55.1,23.9,53.8,24 L53.8,24z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 114,
    height: 114
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 54,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -23.6097 56.9993)",
    className: "st0",
    width: 104.8,
    height: 6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContrastAltH);
export default __webpack_public_path__ + "static/media/icon_contrast_alt_h.defa9f641dc374b7698b9b9a771a7885.svg";
export { ForwardRef as ReactComponent };